import React from "react";
import PropTypes from "prop-types";

const GraphDown = ({ lineColor, graphColor, style, ...rest }) => {
  return (
    <svg
      style={{ maxWidth: "100%", height: "auto", display: "block", ...style }}
      viewBox="0 0 96 85"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...rest}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-65.000000, -70.000000)" fillRule="nonzero">
          <g transform="translate(65.500000, 70.931500)">
            <g
              transform="translate(43.095000, 61.806300) scale(-1, 1) translate(-43.095000, -61.806300) translate(3.095000, 39.806300)"
              fill={graphColor}
            >
              <path d="M79.54785,1.692 C79.54785,21.765 79.25085,21.765 79.25085,41.8365 C79.25085,42.5685 78.53235,43.437 77.28735,43.437 C68.34585,43.437 68.34585,43.2465 59.40285,43.2465 C58.15785,43.2465 56.59485,42.5685 56.59485,41.8365 C56.59485,21.765 57.82185,21.765 57.82185,1.692 C57.82185,0.963 58.15785,0.678 59.40285,0.678 C68.34585,0.678 68.34585,3.55271368e-15 77.28735,3.55271368e-15 C78.53235,3.55271368e-15 79.54785,0.963 79.54785,1.692"></path>
              <polygon points="50.77905 12.4329 50.47755 27.2349 51.24405 42.0324 48.63555 43.0029 30.74955 43.5039 28.94505 42.0324 29.08455 27.2484 28.21905 12.4329 30.74955 11.4954 48.63555 11.7519"></polygon>
              <polygon points="24.0735 19.80555 23.385 31.13955 24.4755 42.48405 20.889 41.95305 3.216 42.61455 -2.22044605e-13 42.49755 0.897 31.14105 1.716 19.95405 3.195 19.99605 20.9955 19.93305"></polygon>
            </g>
            <polygon
              fill={lineColor}
              transform="translate(47.489150, 29.581950) scale(-1, 1) rotate(-180.000000) translate(-47.489150, -29.581950) "
              points="94.6334 0.39945 89.6249 22.42545 86.0669 32.65395 78.0764 28.21695 60.1319 44.57145 55.9814 49.15845 55.9904 49.74645 55.8104 50.77845 54.4469 50.70195 51.4844 53.88645 49.4009 54.83595 44.2904 52.02195 32.1254 44.30895 27.7169 40.54245 24.8114 44.24145 8.0234 58.24695 6.2399 58.24545 5.5739 58.76445 5.1899 57.97095 0.3449 55.32345 0.4094 52.90245 5.8349 47.25345 23.5349 30.07095 25.1159 30.14895 27.1244 29.36445 48.4979 42.44295 68.1269 21.88845 58.4159 15.60195"
            ></polygon>
          </g>
        </g>
      </g>
    </svg>
  );
};

GraphDown.propTypes = {
  lineColor: PropTypes.string.isRequired,
  graphColor: PropTypes.string.isRequired,
};

export default GraphDown;
